
const rtl = (document.querySelector('html').getAttribute('dir') == 'rtl');
/**
 * Villa Hero
 */
function VillaHero (el) {
  if(!el) return false;
  this.el = el;
  this.init();
}
VillaHero.prototype.init = function () {
  this.slider = new VillaHeroSlider(this.el.querySelector('[data-villa-hero-slider]'));
  this.nav = new VillaHeroNav(this.el.querySelector('[data-villa-hero-thumbnav]'));

  if (!this.slider || !this.nav) return false;
  this.relaySliderEvents();
  this.slider.initSlick();

  $(this.el).find('input[type="range"]').on('touchstart mousedown', function(event){
    event.stopPropagation();
  })
  if(!history.state) {
    history.replaceState({ page: 'villa', villaId: window.location.pathname.split('villa/')[1] }, '');
  }
}
VillaHero.prototype.relaySliderEvents = function () {
  const hero = this;
  $(hero.slider.el).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		hero.nav.update(nextSlide);
    //console.log(slick.$slides)
    let currentVideo = slick.$slides[currentSlide].querySelector('video');
    let nextVideo = slick.$slides[nextSlide].querySelector('video');
    //console.log(slick.$slides[currentSlide])
    if (currentVideo && !currentVideo.paused) {
      currentVideo.pause()
    }
    if (nextVideo && nextVideo.paused) {
      nextVideo.play()
    }

    hero.dynamicOverlay(slick.$slides[nextSlide].querySelector('[data-slide]'));
	})
	$(hero.slider.el).on('init', function (event, slick){
		hero.nav.init(hero.slider.groups, slick.currentSlide, hero.slider.goto.bind(hero.slider));
    hero.dynamicOverlay(slick.$slides[slick.currentSlide].querySelector('[data-slide]'));
	})
}
VillaHero.prototype.dynamicOverlay = function (slide) {
  //console.log(slide);
  const group = slide.getAttribute('data-group');
  const contents = Array.from(this.el.querySelectorAll(`[data-target-group]`));
  if (contents.length > 0) {
    contents.forEach((item, index) => {
      if (item.getAttribute('data-target-group') === group) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    })
  }
}



/**
 * Villa Slider Thumb Nav
 */
function VillaHeroNav (el) {
  if(!el) return false;
  this.el = el;
}
VillaHeroNav.prototype.init = function (sliderGroups, currentIndex, goto) {
  this.thumbs = this.el.querySelectorAll('[data-thumb]');
  
  Array.from(this.thumbs).forEach((thumb, index) => {
    let groupName = thumb.getAttribute('data-group');
    let markerBar = document.createElement('div');
        markerBar.setAttribute('class', 'marker-bar');
    let activeThumb = false;

    sliderGroups[groupName].slides.forEach((slide, index) => {
      let marker = document.createElement('div');
          marker.setAttribute('class', 'marker');
          marker.setAttribute('data-group-index', index);
          marker.setAttribute('data-slide-index', slide.getAttribute('data-slide-index'));
          if (slide.getAttribute('data-title'))
            marker.innerHTML = `<span class="title">${slide.getAttribute('data-title')}</span>`;
          markerBar.appendChild(marker);

      if(currentIndex === parseInt(slide.getAttribute('data-slide-index'))) {
        activeThumb = true;
        marker.classList.add('active');
      }
    });
    if(activeThumb) {
      thumb.classList.add('active');
    }
    thumb.appendChild(markerBar);

    thumb.addEventListener('click', this.navigate.bind(this));
  });

  this.sliderGoto = goto;
}
VillaHeroNav.prototype.update = function (nextIndex) {
  const activeMarker = this.el.querySelector('.marker.active');
  const activeThumb = this.el.querySelector('[data-thumb].active');
  const nextMarker = this.el.querySelector(`.marker[data-slide-index="${nextIndex}"]`);
  const nextThumb = nextMarker.parentElement.parentElement;

  activeMarker.classList.remove('active');
  activeThumb.classList.remove('active');
  nextMarker.classList.add('active');
  nextThumb.classList.add('active');
}
VillaHeroNav.prototype.navigate = function (event) {
  const nextThumb = event.target;
  const possibleMarkers = nextThumb.querySelectorAll('.marker');
  let nextMarker = possibleMarkers[0];
  if (nextThumb.classList.contains('active')) {
    if (possibleMarkers.length > 1) {
      let activeMarker = nextThumb.querySelector('.marker.active');
      nextMarker = activeMarker.nextElementSibling ? activeMarker.nextElementSibling : activeMarker.parentElement.firstElementChild;
    } else {
      return;
    }
  }
  this.sliderGoto(nextMarker.getAttribute('data-slide-index'));
}


/**
 * Villa Hero Slider (slick)
 */
function VillaHeroSlider (el) {
  if(!el) return false;
  this.el = el;
  this.groups = {};
  this.init();
}
VillaHeroSlider.prototype.init = function () {
  this.slides = this.el.querySelectorAll('[data-slide]');
  Array.from(this.slides).forEach((slide, index) => {
    let group = slide.getAttribute('data-group');
    slide.setAttribute('data-slide-index', index);
    if (this.groups[group] === undefined) {
      this.groups[group] = {
        slides: []
      }
    }
    this.groups[group].slides.push(slide);
  });
}

VillaHeroSlider.prototype.initSlick = function () {
  this.prevArrow = document.querySelector('[data-villa-hero-pager][data-dir-prev]');
  this.nextArrow = document.querySelector('[data-villa-hero-pager][data-dir-next]');
  $(this.el).slick({
    speed: 1000,
    slidesToShow: 1,
    infinite: false,
    autoplay: false,
    arrows: true,
    dots: false,
    prevArrow: this.prevArrow,
    nextArrow: this.nextArrow,
    rtl
  });
}

VillaHeroSlider.prototype.goto = function (index) {
  $(this.el).slick('slickGoTo', index);
}




export default function () {
  const hero = new VillaHero(document.querySelector('[data-villa-hero]'));
}



// WEBPACK FOOTER //
// ./public/javascripts/modules/villa.js